export const RESET_CURRENT_WARD = "RESET_CURRENT_WARD";
export const FETCH_LIST_WARD_REQUEST = "FETCH_LIST_WARD_REQUEST";
export const FETCH_LIST_WARD_SUCCESS = "FETCH_LIST_WARD_SUCCESS";
export const FETCH_LIST_WARD_FAILURE = "FETCH_LIST_WARD_FAILURE";

// View single WARD
export const FETCH_WARD_REQUEST = "FETCH_WARD_REQUEST";
export const FETCH_WARD_SUCCESS = "FETCH_WARD_SUCCESS";
export const FETCH_WARD_FAILURE = "FETCH_WARD_FAILURE";

// Add WARD
export const ADD_WARD_REQUEST = "ADD_WARD_REQUEST";
export const ADD_WARD_SUCCESS = "ADD_WARD_SUCCESS";
export const ADD_WARD_FAILURE = "ADD_WARD_FAILURE";

// Edit WARD
export const UPDATE_WARD_REQUEST = "UPDATE_WARD_REQUEST";
export const UPDATE_WARD_SUCCESS = "UPDATE_WARD_SUCCESS";
export const UPDATE_WARD_FAILURE = "UPDATE_WARD_FAILURE";

// Delete WARD
export const DELETE_WARD_REQUEST = "DELETE_WARD_REQUEST";
export const DELETE_WARD_SUCCESS = "DELETE_WARD_SUCCESS";
export const DELETE_WARD_FAILURE = "DELETE_WARD_FAILURE";

export const FETCH_LIST_ALL_WARD_REQUEST = "FETCH_LIST_ALL_WARD_REQUEST";
export const FETCH_LIST_ALL_WARD_SUCCESS = "FETCH_LIST_ALL_WARD_SUCCESS";
export const FETCH_LIST_ALL_WARD_FAILURE = "FETCH_LIST_ALL_WARD_FAILURE";

export const FETCH_LIST_WEEK_ID_REQUEST = "FETCH_LIST_WEEK_ID_REQUEST";
export const FETCH_LIST_WEEK_ID_SUCCESS = "FETCH_LIST_WEEK_ID_SUCCESS";
export const FETCH_LIST_WEEK_ID_FAILURE = "FETCH_LIST_WEEK_ID_FAILURE";

export const FETCH_LIST_ALLS_WARD_REQUEST = "FETCH_LIST_ALLS_WARD_REQUEST";
export const FETCH_LIST_ALLS_WARD_SUCCESS = "FETCH_LIST_ALLS_WARD_SUCCESS";
export const FETCH_LIST_ALLS_WARD_FAILURE = "FETCH_LIST_ALLS_WARD_FAILURE";

export const FETCH_COMMON_WARD_REQUEST = "FETCH_COMMON_WARD_REQUEST";
export const FETCH_COMMON_WARD_SUCCESS = "FETCH_COMMON_WARD_SUCCESS";
export const FETCH_COMMON_WARD_FAILURE = "FETCH_COMMON_WARD_FAILURE";

